import React, { useEffect, useMemo, useState } from 'react'
import { Badge, Button, DatePicker, Dropdown, Form, Input } from 'antd'
import { Tuning2OutlineIcon } from '../../components/AppIcon'
import { DATE_FORMAT_DEFAULT, ISO_DATE_FORMAT } from '../../constants'
import { useHistory, useLocation } from 'react-router-dom'
import queryString from 'query-string'
import moment from 'moment'
import { checkValidFormFieldValue } from '../../utils/helper'
import { inject, observer } from 'mobx-react'

const { useForm, useWatch } = Form

const RiskListAdvancedFilter = ({ riskStore }) => {
  const [showFilter, setShowFilter] = useState(false)

  const { setQueryParams, getRisks } = riskStore

  const location = useLocation()
  const history = useHistory()

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const [form] = useForm()
  const values = useWatch([], form)
  const { setFieldsValue } = form
  const riskType = useWatch('type', form)

  const hasFormValue = useMemo(
    () => Object.values(values || {}).some(checkValidFormFieldValue),
    [values]
  )

  const { page, size, active, ...queryObj } = useMemo(
    () => queryString.parse(location.search),
    [location.search]
  )

  useEffect(() => {
    if (!showFilter) return
    setFieldsValue({
      keyword: queryObj.keyword || null,
      createdAt: queryObj.createdAt
        ? moment(queryObj.createdAt, ISO_DATE_FORMAT)
        : null,
    })
  }, [queryObj.createdAt, showFilter])

  const handleClearFilter = () => {
    setFieldsValue({
      keyword: '',
      createdAt: null,
    })
    const query = {
      active: false,
      type: riskType,
      page: 0,
      size,
    }
    setQueryParams('keyword', null)
    setQueryParams('createdAt', null)
    setQueryParams('filterPage', 0)
    setQueryParams('filterSize', size)
    setQueryParams('active', false)
    history.push(`/risk?${queryString.stringify(query)}`)
    getRisks()
  }

  const onSubmit = values => {
    const query = {
      active: false,
      type: values.type,
      page: 0,
      size,
    }
    values.keyword && setQueryParams('keyword', values.keyword)
    values.createdAt &&
      setQueryParams(
        'createdAt',
        moment(values.createdAt).format(ISO_DATE_FORMAT)
      )
    setQueryParams('filterPage', 0)
    setQueryParams('filterSize', size)
    setQueryParams('active', false)
    history.push(`/risk?${queryString.stringify(query)}`)
    getRisks()
  }

  return (
    <Dropdown
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div className="custom-page-filter-dropdown-container ">
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <div className="form-elements">
              <Form.Item name={'keyword'} label={'Tiêu đề'}>
                <Input allowClear placeholder={'Tìm kiếm phiếu rủi ro'} />
              </Form.Item>

              <Form.Item name={'createdAt'} label={'Ngày tạo'}>
                <DatePicker
                  style={{ marginRight: '16px', width: '100%' }}
                  allowClear
                  placeholder={'Ngày tạo'}
                  format={DATE_FORMAT_DEFAULT}
                />
              </Form.Item>
            </div>
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button className="custom-ant-button" onClick={onToggleFilter}>
                Đóng
              </Button>
              <Button
                className="custom-ant-button"
                type={'text'}
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                onClick={handleClearFilter}>
                Xóa
              </Button>
            </div>
          </Form>
        </div>
      )}
      placement="bottomRight">
      <Badge count={0} offset={[-6, -3]}>
        <Button
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

export default inject('riskStore')(observer(RiskListAdvancedFilter))
